import type { EntityData } from '@adornis/baseql/entities/types.js';
import { DropdownSelectionInput } from '@adornis/formfield/fields/dropdown-selection-input.js';
import type { FunctionalForm } from '@adornis/forms/use-form.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { FormGridEntry } from '@martinus/styles/client/FormGridEntry.js';
import { Berufsabschluss } from '@martinus/taetigkeit/enums/Berufsabschluss.js';
import { Schulabschluss } from '@martinus/taetigkeit/enums/Schulabschluss.js';
import { sgNonOptional } from '@martinus/validation/sgNonOptional.js';
import { html, nothing } from 'lit';
import type { Person } from '../../../entities/person.js';

export const EmployeeSectionAusbildungForm = stateful((props: { form: FunctionalForm<EntityData<Person>> }) => {
  if (!props.form.document) return nothing;
  return html`
    <div class="form-grid">
      ${FormGridEntry({
        label: 'Höchster Schulabschluss',
        render: DropdownSelectionInput({
          ...props.form.field('mitarbeiterDaten', 'anAusbildung', 'hoechsterSchulAbschluss'),
          placeholder: 'Kein höchster Schulabschluss hinterlegt',
          placeholderMode: 'hide',
          selectables: Object.values(Schulabschluss).map(s => s.Bezeichnung),
          clearable: true,
        }),
      })}
      ${FormGridEntry({
        label: 'Höchster beruflicher Abschluss',
        render: DropdownSelectionInput({
          ...props.form.field('mitarbeiterDaten', 'anAusbildung', 'hoechsterBerufsAbschluss'),
          placeholder: 'Kein höchster beruflicher Abschluss hinterlegt',
          placeholderMode: 'hide',
          selectables: Object.values(Berufsabschluss).map(b => b.Bezeichnung),
          clearable: true,
        }),
      })}
    </div>
  `;
});

export const EmployeeSectionAusbildungFormValidator = {
  hoechsterSchulAbschluss: sgNonOptional(),
  hoechsterBerufsAbschluss: sgNonOptional(),
};
